<template>
  <div class="wrapper">
    <div class="bg-card">
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.languages.title', 'Languages') }}</strong>
        <b-button
          v-if="$route.name == 'my-cv'"
          class="cv-button"
          @click="$emit('langModalOpen')"
        >
          {{ $t('pages.user-cv.languages.edit-button', 'Edit languages') }}
        </b-button>
      </div>
      <hr>
      <div>
        <div
          v-if="languages"
          class="row"
        >
          <div
            v-for="language in JSON.parse(languages)"
            :key="language.title"
            class="col col-md-6 col-lg-3 mb-3"
          >
            <div class="title">
              {{ $t(`generic.${language.title}`, language.title) }}
            </div>
            <div style="font-size: 0.8rem">
              <div>
                <strong>{{ $t('pages.user-cv.languages.speaking', 'Speaking') }}:</strong> {{ $t(`data.languageLevels.${language.speak}`, language.speak) }}
              </div>
              <div>
                <strong>{{ $t('pages.user-cv.languages.writing', 'Writing') }}:</strong> {{ $t(`data.languageLevels.${language.write}`, language.write) }}
              </div>
              <div>
                <strong>{{ $t('pages.user-cv.languages.reading', 'Reading') }}:</strong> {{ $t(`data.languageLevels.${language.read}`, language.read) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    languages: {
      type: String,
      default: ""
    }
  }
}
</script>


<style scoped lang="scss">
  .title {
    font-weight: 600;
    color: #2c3e50;
    text-transform: uppercase;
    font-size: 0.95rem;
  }

  .levels {
    display: flex;
    margin-left: 0.5rem;

    .level {
      margin-right: 2rem;
    }

    .second-li {
      list-style-type: circle;
      font-size: 0.9rem;
    }
  }

  ul {
    margin-bottom: 0;
  }

   ul li {
    padding: 0 15px;
  }
</style>
